var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6291",
    "data-name": "Group 6291",
    transform: "translate(-2078 545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5963",
    "data-name": "Group 5963",
    transform: "translate(1841 -1508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    transform: "translate(237 963)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 1.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5368",
    "data-name": "Rectangle 5368",
    width: 8,
    height: 2,
    transform: "translate(2083 -537)",
    fill: "#002340"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5369",
    "data-name": "Rectangle 5369",
    width: 8,
    height: 2,
    transform: "translate(2088 -540) rotate(90)",
    fill: "#002340"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.826b0daf.svg";
export { ForwardRef as ReactComponent };